import { render } from "./EditEmail.vue?vue&type=template&id=5a4d805b"
import script from "./EditEmail.vue?vue&type=script&lang=js"
export * from "./EditEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__